<template>
<v-card outlined elevation="2">
    <v-card-title class="py-2 d-flex justify-space-between">
        <div>
            {{ user.username }}
        </div>
        <div class="d-flex align-center">
            <v-chip class="mr-2" label small color="primary" v-if="user.is_active">ACTIVO</v-chip>
            <v-chip class="mr-2" label small v-else>INACTIVO</v-chip>
            <UserModal @saved="saved($event)" :user="user">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" :disabled="fetching" small outlined><v-icon small>mdi-account-edit</v-icon>EDITAR</v-btn>
                </template>
            </UserModal>
        </div>
    </v-card-title>
    <v-divider/>
    <v-card-text>
        <v-card class="text-center pa-4" outlined v-if="fetching">
            CARGANDO
        </v-card>
        <template v-else>
            <template v-if="list.length">
                <div class="d-flex flex-wrap">
                    <ListItem
                        class="mr-2 mb-2"
                        v-for="(juegoSet, index) in list"
                        :key="`user-${user.id}-juego-set-${index}-${juegoSet.id}-item`"
                        :user="user"
                        :juegoSet="juegoSet"
                        @deleted="remove($event)"
                        />
                </div>
            </template>
            <template v-else>
                <v-card class="text-center pa-4" outlined>
                    SIN JUEGOS ASIGNADOS
                </v-card>
            </template>
        </template>
    </v-card-text>
    <v-divider/>
    <v-card-actions class="d-flex justify-end align-center flex-wrap">
        <SelectorJuego
            v-model="juego_id"
            class="mr-2"
            dense
            :filled="false"
            :autoselect="false"
            :filter="juego => !list.some(juegoSet => juegoSet.juego_id == juego.id)"
            :juego.sync="juego"
            />
        <v-btn
            small
            :disabled="!canAddGame"
            @click="addTemporalJuegoSet"
            >
            <v-icon>mdi-plus</v-icon>Añadir
        </v-btn>
    </v-card-actions>
</v-card>
</template>
<script>
import JuegoSetService from '@/services/operadora/institution/JuegoSetService';

import ListItem from './list.item.vue';
import UserModal from '@components/entities/institution/user/modal.vue';

export default {
    components: {
        ListItem,
        UserModal
    },
    props: {
        user: {
            required: true,
        },
    },
    data: function () {
        return {
            juego: null,
            juego_id: null,

            fetching: false,
            list: [],
            count: 0,
        };
    },
    computed: {
        canAddGame: function () {
            if (this.fetching) return false;
            if (!this.juego_id) return false;
            return true;
        }
    },
    methods: {
        fetch: async function () {
            this.fetching = true;

            this.list = [];
            this.count = 0;

            try {
                const {
                    list
                } = await JuegoSetService.getList(this.user.id);

                this.list = list;
                this.count = list.length;
            } catch (error) {
                // ERROR
            }

            this.fetching = false;
        },
        addTemporalJuegoSet: function () {
            const juego = this.juego;

            this.list.push({
                juego_id: juego.id,
                juego: {
                    id: juego.id,
                    name: juego.name,
                },
                is_active: true,
                percent_venta: 0,
                percent_premio: 0,
            });
            
            this.juego_id = null;
        },
        remove: function (juegoSet) {
            const index = this.list.findIndex(item => item.juego_id == juegoSet.juego_id);
            if (index === -1) return;
            this.list.splice(index, 1);
        },
        saved: function (user) {
            this.$emit('saved', user);
        }
    },
    mounted: function () {
        this.list = this.user.juego_set_list;
    }
}
</script>